import BusinessRoutePath from 'app/business-app/BusinessRoutePath';
import {
  useCalendar,
  useNotification,
  useSetRepairersActivity,
} from 'app/core/api/company/api-company';
import {
  CalendarData,
  CalendarWidgetDto,
  PageDetails,
} from 'app/core/api/company/api-company.types';
import Icon from 'app/shared/components/icon/Icon';
import IconLib from 'app/shared/components/icon/icon-lib';
import { useSetPageTitle } from 'app/shared/context-hooks/use-titlebar.hook';
import styledFuncs from 'app/styles/styledFuncs';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Calendar from 'react-awesome-calendar';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components/macro';
import AppImage from 'app/shared/components/app-image/AppImage';
import { DefaultUserImg } from 'app/shared/components/misc';
import { Tabs, Tab } from '@material-ui/core';
import styledMixins from 'app/styles/styledMixins';
import { useEffectOnce } from 'app/tools/hooks/misc-hooks';
import CalendarInfo from '../notifications/CalendarInfo';

const LinkButton = styled.a`
  margin: ${styledFuncs.pad(0.5)} 0;
  justify-content: start;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #eaeaea;
  display: block;
  margin: 10px !important;
  padding: 10px 45px 10px 10px;
  color: black;
  b {
    font-size: 13px;
    font-weight: bold;
    display: block;
    color: black;
  }
  text {
    font-size: 10px;
    color: black;
  }
`;
const LinkRightIcon = styled(Icon).attrs({
  icon: IconLib.CHEVRON_RIGHT,
})`
  position: absolute;
  right: ${styledFuncs.pad(4)};
  margin-top: -82px;
`;

const CalendarTabs = styled(Tabs)`
  ${styledMixins.softShadow}
`;

export default function BusinessCalendar(): JSX.Element {
  const history = useHistory();
  const { request$: repairActivity } = useSetRepairersActivity();
  useEffectOnce(() => {
    const pageDetails: PageDetails = {
      pagename: 'Calendar',
    };
    repairActivity(pageDetails).subscribe();
  });
  const {
    resource: calendar,
    // loadingMissing: loadingMissingCompany,
  } = useCalendar();
  const { resource: notifications } = useNotification();
  useSetPageTitle('Calendar');
  const [calendarData, setCalendarData] = useState<
    CalendarWidgetDto[]
  >([]);
  const [calendarListData, setCalendarListData] = useState<
    CalendarData[]
  >([]);
  const [selectedDate, setSelectedDate] = useState<string>(
    moment(new Date()).format('yyyy-MM-DD')
  );
  const [activeTab, setActiveTab] = useState(1);

  useEffect(() => {
    if (calendar) {
      const detail = calendar.map(
        val =>
          ({
            id: val.repairId,
            title: val.deliveryType,
            from: `${val.date ?? ''} ${val.time ?? ''}`,
            to: `${val.date ?? ''} ${val.time ?? ''}`,
            color: '#6abc35',
          } as CalendarWidgetDto)
      );
      setCalendarData(detail ?? []);
    }
  }, [calendar]);

  useEffect(() => {
    if (calendar) {
      const detail = calendar.filter(
        res => res.date === selectedDate
      );
      setCalendarListData(detail ?? []);
    }
  }, [calendar, selectedDate]);
  const calendarOnChange = (event: {
    mode: string;
    month: number;
    day: number;
    year: number;
  }) => {
    if (event.mode === 'dailyMode') {
      setSelectedDate(
        `${event.year.toString()}-${(event.month + 1)
          .toString()
          .padStart(2, '0')}-${event.day.toString().padStart(2, '0')}`
      );
    }
  };
  const OpenDetail = (id: number) => {
    history.push(`${BusinessRoutePath.REPAIR_CALENDAR_DETAIL}/${id}`);
  };
  const Container = styled.div`
    padding: 10px;
    .yearlyMonth {
      padding: 5px;
      width: calc(100% / 2);
    }
  `;

  return (
    <>
      <CalendarTabs
        value={activeTab}
        onChange={(e, val) => {
          setActiveTab(val as number);
        }}
        variant="fullWidth"
        textColor="primary"
        indicatorColor="primary"
      >
        <Tab
          value={1}
          label="Calendar"
          style={{ textTransform: 'none' }}
        />
        <Tab
          value={2}
          label="Inbox"
          style={{ textTransform: 'none' }}
        />
      </CalendarTabs>

      {activeTab === 1 && (
        <Container>
          <Calendar
            events={calendarData}
            onChange={calendarOnChange}
            onClickEvent={OpenDetail}
          />
          <>
            {calendarListData && calendarListData?.length > 0 && (
              <h3 style={{ color: '#31AD31', fontWeight: 'normal' }}>
                Quick Actions
              </h3>
            )}
            {calendarListData &&
              calendarListData?.length > 0 &&
              calendarListData?.map(res => (
                <LinkButton
                  color="default"
                  key={res.customerName}
                  href={`${BusinessRoutePath.REPAIR_CALENDAR_DETAIL}/${res.repairId}`}
                >
                  <AppImage
                    alt="profile image"
                    src={res.userDetails.userProfilePhoto}
                    fallbackImgNode={<DefaultUserImg size={60} />}
                    height="60px"
                    noPad
                    className="mb-1.5 w-10 h-10 rounded"
                  />
                  <LinkRightIcon size={30} />
                  <div
                    style={{
                      marginLeft: '100px',
                      marginTop: '-100px',
                    }}
                  >
                    <b>{res.deliveryType}</b>
                    {res.customerName}
                    <br />
                    <text>{res.date}</text>
                    <br />
                    <text>{res.time}</text>
                  </div>
                </LinkButton>
              ))}
          </>
        </Container>
      )}
      {activeTab === 2 && (
        <>
          {notifications &&
            notifications?.calenderData?.length > 0 && (
              <CalendarInfo data={notifications.calenderData} />
            )}
        </>
      )}
    </>
  );
}
